var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.252 69.253a8.447 8.447 0 0 1-6.011-2.489L17.736 42.258a8.52 8.52 0 0 1-2.479-6.255 8.527 8.527 0 0 1 2.479-6.261L42.242 5.236a8.443 8.443 0 0 1 6.01-2.489c2.271 0 4.405.884 6.01 2.489 3.314 3.314 3.314 8.707 0 12.021L35.519 36l18.743 18.742c3.314 3.314 3.314 8.707 0 12.021a8.443 8.443 0 0 1-6.01 2.49zm0-62.506a4.474 4.474 0 0 0-3.182 1.317L21.038 32.57c-.891.893-.833 2.084-.833 3.355v.151c0 1.271-.058 2.461.833 3.353l24.269 24.506c.85.85 1.862 1.317 3.063 1.317 1.203 0 2.273-.468 3.123-1.317 1.755-1.755 1.725-4.61-.03-6.365L31.292 37.414a2 2 0 0 1-.007-2.828L51.438 14.43a4.507 4.507 0 0 0-.001-6.365 4.477 4.477 0 0 0-3.185-1.318z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.93c0e2c2.svg";
export { ForwardRef as ReactComponent };